import Analytics from './Analytics';
import RRdef from './Rrdef';
import Sensor from './Sensor';
import Clusterlet from './Clusterlet';
import ExternalFunction from './ExternalFunction';
import Profile from './Profile';
import SubFlowNode from './SubFlowNode';
import UserNode from './UserNode';
import LabelNode from './LabelNode';
import TemplateClusterlet from './TemplateClusterlet.js'
import ControllerDelegate from './ControllerDelegate';
import TemplateDelegate from './TemplateDelagte'

const nodeTypes = {
  analytics: Analytics,
  rrdef: RRdef,
  profile: Profile,
  sensor: Sensor,
  clusterlet: Clusterlet,
  external_function: ExternalFunction,
  section: Profile,
  subFlowNode: SubFlowNode,
  user: UserNode,
  label_node: LabelNode,
  templated_clusterlet: TemplateClusterlet,
  controller_delegate: ControllerDelegate,
  template_delegate: TemplateDelegate,
};

export default nodeTypes;

/*
const nodeTypes = () => ({
  analytics: cloneElement(Analytics, {}),
  rrdef: cloneElement(RRdef, {}),
  profile: cloneElement(Profile, {}),
  sensor: cloneElement(Sensor, {}),
  clusterlet: cloneElement(Clusterlet, {}),
  external_function: cloneElement(ExternalFunction, {}),
});
*/
